var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDistance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 13",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.93 1.862c.31-.81-.484-1.604-1.293-1.293L.64 4.415c-.906.348-.834 1.653.105 1.9l4.024 1.06a.5.5 0 01.357.356l1.059 4.024c.247.94 1.552 1.01 1.9.105l3.845-9.998zm-.934-.36l-3.845 10-1.06-4.026a1.5 1.5 0 00-1.068-1.069L.998 5.348l9.998-3.846z",
    fill: "#333230"
  })));
}
export default SvgDistance;